export const trackDetails = {
  title: 'Jackboys 2 (feat. Travis Scott)',
  artists: 'Don Toliver, Travis Scott',
  releaseDate: '2025-04-13',
};

export const streamingBenchmarks = {
  firstWeek: 7_000_000,
  secondWeek: 14_000_000,
  firstYear: 364_000_000,
};
